"use client";

import React from "react";
import { motion } from "framer-motion";
import Image from "next/image";

const fadeUp = {
    initial: { opacity: 0, y: 24 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.7 },
};

export interface GuestiqoGalleryBlockProps {
    image1?: string;
    alt1?: string;
    image2?: string;
    alt2?: string;
}

export default function GuestiqoGalleryBlock({
    image1 = "/images/guestiqo_guidebook_builder.png",
    alt1 = "Guestiqo Guidebook Builder dashboard",
    image2 = "/images/guestiqo_guest_access_poster.png",
    alt2 = "Guestiqo Guest Access poster builder"
}: GuestiqoGalleryBlockProps) {
    return (
        <section className="py-20 px-6 md:px-12 lg:px-24 bg-[#FDFBF7] w-full" data-header-theme="dark">
            <div className="container mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <motion.div {...fadeUp} className="overflow-hidden rounded-xs border border-[#1C1C1C]/10 p-2 bg-[#FAF7F2]">
                        <div className="w-full overflow-hidden">
                            {image1 && (
                                <Image 
                                    src={image1} 
                                    alt={alt1} 
                                    width={2048}
                                    height={925}
                                    className="w-full h-auto"
                                    sizes="(max-w-md) 100vw, 600px"
                                />
                            )}
                        </div>
                    </motion.div>
                    <motion.div {...fadeUp} transition={{ delay: 0.2 }} className="overflow-hidden rounded-xs border border-[#1C1C1C]/10 p-2 bg-[#FAF7F2]">
                        <div className="w-full overflow-hidden">
                            {image2 && (
                                <Image 
                                    src={image2} 
                                    alt={alt2} 
                                    width={2048}
                                    height={925}
                                    className="w-full h-auto"
                                    sizes="(max-w-md) 100vw, 600px"
                                />
                            )}
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
